import React, { useContext, useEffect, useState } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';
import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import * as AppUtils from '@/utilities/AppUtils';
import { CustomText } from '@/components/CustomText';
import { Button, Fieldset, Panel, Radio, Text } from 'react95-native-rabbl';
import * as AppConstants from '@/utilities/AppConstants';
import { AppContext } from '@/components/AppContext';
import * as AppUtilities from "@/utilities/AppUtilities";
import Footer from '@/components/Footer';
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import * as AppConsts from '@/utilities/AppConsts';
import { Meta } from '@/components/Meta';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: 'center',
    backgroundColor: 'transparent',
    gap: 20,
  },
  contentWrapper: {
    padding: 20,
    gap: 20,
  },
});

export default function PayComplete() {
  const community = useSelector((state: RootState) => state.user.current_community);
  const { showSpinner, hideSpinner } = useContext(AppContext);
  
  const onSubmit = async () => {
    try {
      showSpinner();

      //throw new Error("Not implemented");

    } catch (e) {
      AppUtils.showErrorToast(AppUtilities.getErrors(e), () => onSubmit(), true);
      AppUtilities.handleException(e, "Join.onSubmit");
    } finally {
      hideSpinner();
    }
  };

  return (
    <BasicScrollView center={true}>
      <Meta title={"Payment complete"} />
      <Panel variant='raised' elevation={4}>
        <View style={AppConstants.STYLES.padding20gap10center}>
          <CustomText>{community.name}</CustomText>
        </View>
      </Panel>
      <Footer />
    </BasicScrollView>
  );
}
